namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    export interface FilterByEntry {
        id: string;
        containsText?: string;
        numberMatch?: FilterByNumberMatch;
        boolMatch?: FilterByBoolMatch;
        tagsMatch?: FilterByTagsMatch;
        valueTypesMatch?: FilterByValueTypesMatch[];
    }

    export interface FilterByNumberMatch {
        min?: number;
        max?: number;
        notSet?: boolean;        
    }

    export interface FilterByBoolMatch {
        yes?: boolean;
        no?: boolean;
        notSet?: boolean;
    }

    export interface FilterByTagsMatch {
        notSet?: boolean;
        includeAllRootTags?: boolean;
        enabledTags?: FilterByTagMatchEntry[];
    }

    export interface FilterByTagMatchEntry {
        tagId: number;
        includeChildTags?: boolean;
        excludeTag?: boolean;
    }

    export interface FilterByValueTypesMatch {
        text: string;
        key: number;
        selected: boolean;
        expanded?: boolean;
        disabled?: boolean;
        parent?: FilterByValueTypesMatch;
        itemData?: {
            selected: boolean;
            id: number;
            label: string;
        };
        children?: FilterByValueTypesMatch[];
        items?: FilterByValueTypesMatch;
    }

    export interface FilterManagerOptions {
        tableControl: DataTableControl;
        filterBy: FilterByEntry[];
    }

    /*
     * FilterManager relies on the SortManager to determine what can be filtered.    
     */
    export class FilterManager {

        public tableControl: DataTableControl;
        public _filterBy: FilterByEntry[];
    
        constructor(options: FilterManagerOptions) {
            var self = this;

            this.tableControl = options.tableControl;

            this._filterBy = [];
            this.updateFilterByList(options.filterBy);   
        }

        public updateFilterByList(filterBy) {
            var newFilterByList = [];

            $(filterBy).each(function (i, entry: any) {
                var entryCopy: any = {
                };

                for (var key in entry) {
                    if (entry.hasOwnProperty(key)) {
                        entryCopy[key] = entry[key];
                    }
                }

                if (entryCopy.containsText) {
                    entryCopy.containsTextLower = entryCopy.containsText.toString().toLowerCase();
                }

                newFilterByList.push(entryCopy);
            });

            this._filterBy = newFilterByList;

            this.notifyFilterByChanged();
        }

        public notifyFilterByChanged() {
            $(this).trigger("filterByChanged");
        }

        public getFilterByList(): FilterByEntry[] {
            var filterByList: FilterByEntry[] = [];

            if (this._filterBy) {
                for(let entry of this._filterBy) {
                    let entryCopy: FilterByEntry = {
                        id: entry.id
                    };

                    if (Solovis.isNotNull(entry.containsText)) {
                        entryCopy.containsText = entry.containsText;
                    }

                    if (Solovis.isNotNull(entry.numberMatch)) {
                        entryCopy.numberMatch = entry.numberMatch;
                    }                   

                    if (Solovis.isNotNull(entry.boolMatch)) {
                        entryCopy.boolMatch = entry.boolMatch;
                    }

                    if (Solovis.isNotNull(entry.tagsMatch)) {
                        entryCopy.tagsMatch = entry.tagsMatch;
                    }

                    if (Solovis.isNotNull(entry.valueTypesMatch)) {
                        entryCopy.valueTypesMatch = entry.valueTypesMatch;
                    }

                    filterByList.push(entryCopy);
                }
            }

            return filterByList;
        }


        public isFilteringEnabled() {
            if (this._filterBy && this._filterBy.length > 0) {
                return true;
            }

            return false;
        }

        public filterRawRows(rowList, customFilter) {
            let useGroupedMode = false;
            return this._internalFilterRows(rowList, customFilter, useGroupedMode);
        }

        public filterGroupedRows(rowList, customFilter) {
            let useGroupedMode = true;
            return this._internalFilterRows(rowList, customFilter, useGroupedMode);
        }

        public _internalFilterRows(rowList, customFilter, useGroupedMode) {
            let self = this;

            let columnSet = this.tableControl.columnSet;
            let sortManager = this.tableControl.sortManager;

            let filteredRows = [];

            $(rowList).each(function (i, row: any) {
                let mismatchFound = false;

                let comparisonRow = row;
                if (row._groupId && useGroupedMode) {
                    if (row._backingRow) {
                        comparisonRow = row._backingRow;
                    }
                    else {
                        comparisonRow = null;
                    }
                }

                if (comparisonRow) {
                    $(self._filterBy).each(function (i, filterByEntry) {
                        let col = columnSet.getColumnById(filterByEntry.id);
                        let sort = sortManager.getSortById(filterByEntry.id);

                        if (col) {
                            let sortValue;
                            if (sort) {
                                sortValue = sort.getter(comparisonRow);
                            }
                            let cellValue = self.tableControl._getColumnValueForRow(col, comparisonRow);

                            if (!self._doesValueMatch(filterByEntry, col, sort, sortValue, cellValue)) {
                                mismatchFound = true;
                            }
                        }
                    });

                    if (customFilter) {
                        if (!customFilter(comparisonRow)) {
                            mismatchFound = true;
                        }
                    }
                }

                if (row._groupId && useGroupedMode) {
                    // Handle child rows of group rows.
                    row._rows = self.filterGroupedRows(row._rows, customFilter);

                    if (!_.isEmpty(row._rows)) {
                        // Child row has matches so we have to keep it.
                        mismatchFound = false;
                    }
                    else {
                        if (!row._backingRow) {
                            // Not a backing row on which a comparison was done and there are no child rows,
                            // so remove it.
                            mismatchFound = true;
                        }
                    }
                }

                if (!mismatchFound) {
                    filteredRows.push(row);
                }
            });

            return filteredRows;
        }

        public _doesValueMatch(filter, col, sort, sortValue, cellValue): boolean {
            if (col.dataType === "tagId" && filter.tagsMatch) {
                return this._doesValueMatchAsTag(filter, col, sort, cellValue);
            }
            else if (col.dataType === "valueTypeId" && filter.valueTypesMatch) {
                return this._doesValueMatchAsValueType(filter, col, sort, sortValue)
            }
            else if (col.dataType === "bool" && filter.boolMatch) {
                return this._doesValueMatchAsBool(filter, col, sort, cellValue);
            }
            else if (sort && sort.sortDataType == "string") {
                return this._doesValueMatchAsString(filter, col, sort, sortValue);
            }
            else if ((col.dataType === "currency" || col.dataType === "number" || col.dataType === "percentage" || col.dataType === "integer") && filter.numberMatch) {
                return this._doesValueMatchAsNumber(filter, col, sort, sortValue);
            }
            else {
                return this._doesValueMatchAsString(filter, col, sort, sortValue);
            }            
        }

        public _doesValueMatchAsValueType(filter, _col, _sort, value) {
            return filter.valueTypesMatch.some(
                valueType => valueType.selected && (valueType.text === value || (valueType.text === "(Not Set)" && !value))
            );
        }

        public _doesValueMatchAsBool(filter, col, sort, value) {
            let boolMatch: FilterByBoolMatch = filter.boolMatch;
            if (Solovis.isNotNull(boolMatch)) {
                if (Solovis.isNotNull(value)) {
                    if (boolMatch.yes && value) {
                        return true;
                    }
                    else if (boolMatch.no && !value) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    if (boolMatch.notSet) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }            

            return false;
        }

        public _doesValueMatchAsNumber(filter, col, sort, value) {
            let numberMatch: FilterByNumberMatch = filter.numberMatch;
            if (Solovis.isNotNull(numberMatch)) {
                if (Solovis.isNotNull(value)) {                    
                    if (Solovis.isNotNull(numberMatch.min)) {
                        if (value < numberMatch.min) {
                            return false;
                        }
                    }
                    if (Solovis.isNotNull(numberMatch.max)) {
                        if (value > numberMatch.max) {
                            return false;
                        }
                    }

                    return true;
                }
                else {
                    if (numberMatch.notSet) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }

            return false;
        }

        public _doesValueMatchAsString(filter, col, sort, value) {
            if (filter.containsText) {
                // Treat this as a string comparison.
                if (Solovis.isNotNull(value)) {
                    var valueLower = value.toString().toLowerCase();
                    var containsTextLower = filter.containsTextLower;

                    if (valueLower.indexOf(containsTextLower) >= 0) {
                        return true;
                    }
                }
                else {
                    // containsText is set, but value is null/empty.
                    return false;
                }
            }
            else {
                return true;
            }

            return false;
        }

        public _doesValueMatchAsTag(filter, col, sort, tagId) {
            let tagsMatch: FilterByTagsMatch = filter.tagsMatch;
            if (tagsMatch) {
                if (Solovis.isNull(tagId)) {
                    if (tagsMatch.notSet) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

                if (tagsMatch.includeAllRootTags) {
                    return true;
                }

                let tagSet = this.tableControl.modelEnvironment.tagSets.tryGetById(col.definitionToUse.tagSetId);
                if (tagSet) {
                    let tag = tagSet.tryGetTagById(tagId);
                    if (tag) {
                        if (tagsMatch.enabledTags) {
                            for (let entry of tagsMatch.enabledTags) {
                                if (entry.tagId === tag.id) {
                                    if (entry.excludeTag) {
                                        // We definitively know we are excluding this tag.
                                        return false;
                                    }
                                    else {
                                        // We have an exact match.
                                        return true;
                                    }
                                }
                                else if (entry.includeChildTags) {
                                    let entryTag = tagSet.tryGetTagById(entry.tagId);
                                    if (entryTag && tag.isInBranch(entryTag)) {
                                        // We have found a child tag match.
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return false;
        }
    }

}
